import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, IconButton, Collapse } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Info from './Info';
import DetailTabs from '../DetailTabs';
import { useRowStyles } from './styles';

const Row = ({ ...props }) => {
  const { row, instructions, balance } = props;
  const classes = useRowStyles();
  const [open, setOpen] = useState(false);

  const instruction = instructions.filter(
    (instruction) => instruction.categoryId === row.category,
  );

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          {' '}
          <img src={row.image} className={classes.image} />{' '}
        </TableCell>
        <TableCell>
          <Info
            className={classes.info}
            category={row.category}
            expirationDate={row.expirationDate}
            creationDate={row.createdAt}
            balance={balance}
          />
        </TableCell>
        <TableCell align="right">
          <IconButton onClick={() => setOpen(!open)} data-cy="iconButtonRow">
            {open ? (
              <KeyboardArrowUpIcon fontSize="large" />
            ) : (
              <KeyboardArrowDownIcon fontSize="large" />
            )}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.cell} colSpan={6}>
          <Collapse in={open}>
            <DetailTabs row={row} instructions={instruction[0]} />
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

Row.propTypes = {
  row: PropTypes.object,
  instructions: PropTypes.array,
  balance: PropTypes.string,
};

export default Row;
